// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607211149/js/" + chunkId + "." + {"44":"b10d5cb6","225":"84244fdd","481":"0ed9d811","486":"a51bcdb3","770":"e599640f"}[chunkId] + ".0.38384699585115023.chunk.js";
};